import { useEffect, useState, useCallback } from "react";
// import DashboardLayout from "../../layouts/DashboardLayout";
import AdminLayout from "../../layouts/AdminLayout";
import { FaBell, FaWhatsapp } from "react-icons/fa";
import { useRef } from "react";
import { getAdminNotifications } from "../../services/notificationService";
import { checkExpiryNotifications } from "../../services/gymService";

// import { sendSubscriptionEmail } from "../../services/emailService";
// import { markEmailSent } from "../../services/notificationService";
import { deleteNotification } from "../../services/notificationService";
import { getPlans } from "../../services/subscriptionService";

import {
  getAllGyms,
  approveGym,
  rejectGym,
  extendSubscription,
  deleteGym,
} from "../../services/gymService";

import "./AdminDashboard.css";

export default function AdminDashboard() {
  const [gyms, setGyms] = useState([]);

  const [selectedPlans, setSelectedPlans] = useState({});

  const [search, setSearch] = useState("");
  const [notifications, setNotifications] = useState([]);
  const [plans, setPlans] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [dashboardStats, setDashboardStats] = useState({
    totalGyms: 0,
    activeGyms: 0,
    inactiveGyms: 0,
    pendingGyms: 0,
    trialGyms: 0,
    paidGyms: 0,
    expiredGyms: 0,
    monthlyRevenue: 0,
  });

  const hasRun = useRef(false);

  const initializeDashboard = useCallback(async () => {
    await checkExpiryNotifications();
    await loadGyms();
    await loadNotifications();
  }, []);

  useEffect(() => {
    if (hasRun.current) return;

    hasRun.current = true;

    initializeDashboard();
  }, [initializeDashboard]);

  // useEffect(() => {
  //   if (hasRun.current) return;

  //   hasRun.current = true;

  //   initializeDashboard();
  // }, []);

  // const initializeDashboard = async () => {
  //   await checkExpiryNotifications();

  //   await loadGyms();

  //   await loadNotifications();
  // };

  const loadGyms = async () => {
    try {
      // const data = await getAllGyms();

      // setGyms(data);
      const [data, planData] = await Promise.all([getAllGyms(), getPlans()]);

      setGyms(data);
      setPlans(planData);

      const totalGyms = data.length;

      const activeGyms = data.filter(
        (gym) => gym.subscriptionStatus === "Active",
      ).length;

      const inactiveGyms = data.filter(
        (gym) => gym.subscriptionStatus !== "Active",
      ).length;

      const pendingGyms = data.filter((gym) => gym.status === "Pending").length;

      const trialGyms = data.filter(
        (gym) => gym.registrationType === "trial",
      ).length;

      const paidGyms = data.filter(
        (gym) => gym.registrationType === "paid",
      ).length;

      const expiredGyms = data.filter((gym) => {
        if (!gym.subscriptionEndDate) return false;

        return new Date(gym.subscriptionEndDate) < new Date();
      }).length;

      const plans = await getPlans();

      const monthlyRevenue = data.reduce((sum, gym) => {
        if (gym.subscriptionStatus !== "Active") return sum;

        const plan = plans.find(
          (p) =>
            p.planName === gym.subscriptionPlan &&
            p.duration === gym.subscriptionDuration,
        );

        return sum + Number(plan?.price || 0);
      }, 0);

      setDashboardStats({
        totalGyms,
        activeGyms,
        inactiveGyms,
        pendingGyms,
        trialGyms,
        paidGyms,
        expiredGyms,
        monthlyRevenue,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleApprove = async (gymId) => {
    try {
      const plan = selectedPlans[gymId] || "Basic";

      await approveGym(gymId, plan);

      alert(`Gym Approved with ${plan} Plan`);

      loadGyms();
    } catch (error) {
      console.error(error);
    }
  };

  const handleReject = async (gymId) => {
    try {
      await rejectGym(gymId);

      alert("Gym Rejected");

      loadGyms();
    } catch (error) {
      console.error(error);
    }
  };

  const handleExtend = async (gymId) => {
    try {
      await extendSubscription(gymId, 1);

      alert("Subscription Extended By 1 Month");

      loadGyms();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (gymId) => {
    const confirmDelete = window.confirm("Delete this gym?");

    if (!confirmDelete) return;

    try {
      await deleteGym(gymId);

      alert("Gym Deleted");

      loadGyms();
    } catch (error) {
      console.error(error);
    }
  };

  const filteredGyms = gyms.filter(
    (gym) =>
      gym.gymName?.toLowerCase().includes(search.toLowerCase()) ||
      gym.ownerName?.toLowerCase().includes(search.toLowerCase()) ||
      gym.email?.toLowerCase().includes(search.toLowerCase()),
  );

  const loadNotifications = async () => {
    try {
      const data = await getAdminNotifications();

      setNotifications(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSendWhatsApp = (notification) => {
    const message = ` *${notification.gymName}*

Hello *${notification.ownerName || "Gym Owner"}*,

 This is a reminder that your *${notification.subscriptionPlan || "Gym"}* subscription is expiring soon.

 Expiry Date: *${notification.subscriptionEndDate}*

Please renew your subscription before the expiry date to continue using all premium features.

If you need any assistance, feel free to contact us.

Thank you!

*NN FIT*
 +91 8688663447
 www.nnaisolution.com`;

    window.open(
      `https://wa.me/91${notification.phone}?text=${encodeURIComponent(message)}`,
      "_blank",
    );
  };

  // const handleSendEmail = async (notification) => {
  //   try {
  //     await sendSubscriptionEmail(notification);

  //     await markEmailSent(notification.id);

  //     alert("Email sent successfully.");

  //     loadNotifications();
  //   } catch (error) {
  //     console.error(error);

  //     alert("Failed to send email.");
  //   }
  // };

  const handleDeleteNotification = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this notification?",
    );

    if (!confirmDelete) return;

    try {
      await deleteNotification(id);

      alert("Notification deleted successfully.");

      loadNotifications();
    } catch (error) {
      console.error(error);
      alert("Failed to delete notification.");
    }
  };

  const formatLastLogin = (lastLogin) => {
    if (!lastLogin) return "-";

    const now = new Date();
    const login = new Date(lastLogin);

    const diff = Math.floor((now - login) / 1000);

    if (diff < 60) return "Just now";

    if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;

    if (diff < 86400) return `${Math.floor(diff / 3600)} hrs ago`;

    if (diff < 172800) return "Yesterday";

    return `${Math.floor(diff / 86400)} days ago`;
  };

  return (
    <AdminLayout>
      <div className="admin-container">
        <div className="admin-topbar">
          <div
            className="notification-bell"
            onClick={() => setShowNotifications(!showNotifications)}
          >
            <FaBell />

            {notifications.filter((n) => !n.read).length > 0 && (
              <span>{notifications.filter((n) => !n.read).length}</span>
            )}
          </div>
        </div>

        <div className="admin-header">
          <div>
            <h1>Super Admin Dashboard</h1>

            <p>
              Manage gym subscriptions, approvals and monitor business growth.
            </p>
          </div>
        </div>

        {showNotifications && (
          <div className="notification-dropdown">
            {notifications.length > 0 ? (
              notifications.map((item) => (
                <div key={item.id} className="notification-item">
                  <h4>{item.type}</h4>

                  <p>{item.message}</p>

                  <small>{item.gymName}</small>

                  <div className="notification-actions">
                    <button
                      className="whatsapp-btn"
                      onClick={() => handleSendWhatsApp(item)}
                    >
                      <FaWhatsapp />
                      {/* WhatsApp */}
                    </button>

                    <button
                      className="delete-notification-btn"
                      onClick={() => handleDeleteNotification(item.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <p>No Notifications</p>
            )}
          </div>
        )}

        {/* Stats Cards */}

        <div className="admin-stats">
          <div className="admin-card total-card">
            <h3>Total Gyms</h3>
            <h1>{dashboardStats.totalGyms}</h1>
          </div>

          <div className="admin-card active-card">
            <h3>Active Gyms</h3>
            <h1>{dashboardStats.activeGyms}</h1>
          </div>

          <div className="admin-card inactive-card">
            <h3>Inactive Gyms</h3>
            <h1>{dashboardStats.inactiveGyms}</h1>
          </div>

          <div className="admin-card pending-card">
            <h3>Pending Approval</h3>
            <h1>{dashboardStats.pendingGyms}</h1>
          </div>

          <div className="admin-card trial-card">
            <h3>Trial Gyms</h3>
            <h1>{dashboardStats.trialGyms}</h1>
          </div>

          <div className="admin-card paid-card">
            <h3>Paid Gyms</h3>
            <h1>{dashboardStats.paidGyms}</h1>
          </div>

          <div className="admin-card expired-card">
            <h3>Expired Subscriptions</h3>
            <h1>{dashboardStats.expiredGyms}</h1>
          </div>

          <div className="admin-card revenue-card">
            <h3>Monthly Revenue</h3>
            <h1>₹{dashboardStats.monthlyRevenue}</h1>
          </div>
        </div>

        {/* Gym Table */}

        <div className="table-wrapper">
          <div className="admin-toolbar">
            <input
              type="text"
              placeholder="Search Gym..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="search-input"
            />
          </div>
          <table className="member-table">
            <thead>
              <tr>
                <th>Gym</th>
                <th>Owner</th>
                <th>Phone</th>
                <th>Registration</th>
                <th>Status</th>
                <th>Payment</th>
                <th>Trial</th>
                <th>Plan</th>
                <th>Days Left</th>
                <th>Members</th>
                <th>Trainers</th>
                <th>Revenue</th>
                {/* <th>Storage</th> */}
                <th>Storage Usage</th>
                <th>Last Login</th>
                <th>Email</th>
                <th>Features</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredGyms.length > 0 ? (
                filteredGyms.map((gym) => (
                  <tr key={gym.id}>
                    <td>{gym.gymName}</td>

                    <td>{gym.ownerName}</td>

                    <td>{gym.phone || "-"}</td>

                    <td>
                      <span
                        className={
                          gym.registrationType === "trial"
                            ? "trial-badge"
                            : "paid-badge"
                        }
                      >
                        {gym.registrationType === "trial" ? "Trial" : "Paid"}
                      </span>
                    </td>

                    <td>
                      <span
                        className={
                          gym.status === "Approved"
                            ? "status-approved"
                            : gym.status === "Rejected"
                              ? "status-rejected"
                              : "status-pending"
                        }
                      >
                        {gym.status}
                      </span>
                    </td>
                    <td>
                      <span
                        className={
                          gym.paymentStatus === "Paid"
                            ? "payment-paid"
                            : gym.paymentStatus === "Pending"
                              ? "payment-pending"
                              : "payment-trial"
                        }
                      >
                        {gym.paymentStatus || "-"}
                      </span>
                    </td>

                    <td>
                      {gym.registrationType === "trial" ? (
                        gym.trialUsed ? (
                          <span className="trial-used">Used</span>
                        ) : (
                          <span className="trial-running">Running</span>
                        )
                      ) : (
                        "-"
                      )}
                    </td>

                    {/* <td>{gym.subscriptionPlan}</td> */}
                    <td>
                      <select
                        className="plan-select"
                        value={
                          selectedPlans[gym.id] || gym.subscriptionPlanId || ""
                        }
                        onChange={(e) =>
                          setSelectedPlans({
                            ...selectedPlans,
                            [gym.id]: e.target.value,
                          })
                        }
                      >
                        <option value="">Select Plan</option>

                        {plans.map((plan) => (
                          <option key={plan.id} value={plan.id}>
                            {plan.planName} ({plan.duration})
                          </option>
                        ))}
                      </select>
                    </td>

                    <td>
                      {gym.daysLeft === "-" ? (
                        "-"
                      ) : gym.daysLeft < 0 ? (
                        <span className="expired-text">Expired</span>
                      ) : (
                        `${gym.daysLeft} Days`
                      )}
                    </td>

                    <td>{gym.totalMembers}</td>

                    <td>{gym.totalTrainers}</td>
                    <td>
                      <span className="revenue-badge">
                        ₹{gym.totalRevenue.toLocaleString()}
                      </span>
                    </td>

                    {/* <td>
                      <span className="storage-badge">
                        {(Number(gym.storageUsed || 0) / 1024 / 1024).toFixed(
                          2,
                        )}{" "}
                        MB
                      </span>
                    </td> */}

                    <td>
                      <span className="storage-limit-badge">
                        {(Number(gym.storageUsed || 0) / 1024 / 1024).toFixed(
                          2,
                        )}{" "}
                        MB /{gym.storageLimit || 0} MB
                      </span>
                    </td>
                    {/* <td>
                      {gym.lastLogin
                        ? new Date(gym.lastLogin).toLocaleDateString()
                        : "-"}
                    </td> */}
                    <td>{formatLastLogin(gym.lastLogin)}</td>
                    <td>{gym.email}</td>

                    <td className="feature-cell">
                      {gym.features?.aiWorkout && (
                        <span className="feature-tag">AI</span>
                      )}

                      {gym.features?.dietPlan && (
                        <span className="feature-tag">Diet</span>
                      )}

                      {gym.features?.reports && (
                        <span className="feature-tag">Reports</span>
                      )}

                      {gym.features?.qrScanner && (
                        <span className="feature-tag">QR</span>
                      )}

                      {gym.features?.memberPortal && (
                        <span className="feature-tag">Portal</span>
                      )}
                    </td>

                    <td>
                      <button
                        className="approve-btn"
                        onClick={() => handleApprove(gym.id)}
                      >
                        Approve
                      </button>

                      <button
                        className="reject-btn"
                        onClick={() => handleReject(gym.id)}
                      >
                        Reject
                      </button>

                      <button
                        className="extend-btn"
                        onClick={() => handleExtend(gym.id)}
                      >
                        Extend
                      </button>
                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(gym.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7">No Gyms Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}
